export const sendPromptIcon = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M3 20v-6l8-2l-8-2V4l19 8z"
    />
  </svg>
`
